import React from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import "../styles/ThankYou.css"

const ThankYou = () => {
    return (
        <section>
            <Container>
                <Row>
                    <Col lg="12" className="pt-5 text-center">
                        <div className="thank__you">
                            <span>
                                <i className="ri-checkbox-circle-line"></i>
                            </span>
                            <h1 className="mb-3 fw-semibold">Application Submitted Successfully!</h1>
                            <h3 className="mb-4">Your tour booking request has been received.</h3>

                            <p className="mb-4">
                                Thank you for choosing our travel services! Our team will review your booking request and get back to you within 24 hours via email or phone.
                            </p>

                            <p className="text-muted">
                                <i className="ri-mail-line"></i> Check your email for confirmation details<br />
                                <i className="ri-phone-line"></i> We'll contact you soon to finalize your booking
                            </p>

                            <Button className="btn primary__btn w-25 mt-4">
                                <Link to="/home">Back to Home</Link>
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default ThankYou